import instance from "@/utils/require.js"

// 客户验货记录 - 分页查询
export function apiCustomerCheckRecordSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/customer_check/search",
		method: "post",
		data
	})
}
